import {
  Box,
  Dialog,
  DialogContent,
  Stack,
  styled,
  Typography,
  IconButton,
  Grid,
} from "@mui/material";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(3),
  },
  "& .MuiPaper-root": {
    width: "700px",
    borderRadius: 12,
    [theme.breakpoints.down("sm")]: {
      margin: 12,
      width: "100%",
    },
  },
}));

const ViewImagesDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);
  const [images, setImages] = useState([]);

  useImperativeHandle(ref, () => ({
    openDialog(imagesArray) {
      setImages(imagesArray);
      setOpen(true);
    },
    disable() {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog onClose={handleClose} open={open}>
      <Stack
        p={2}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        borderBottom="1px solid #e0e0e0"
      >
        <Typography variant="h6" fontWeight={600}>
          🖼️ View Images
        </Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Stack>

      <DialogContent>
        {images?.length > 0 ? (
          <Grid container spacing={2}>
            {images.map((img, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Box
                  component="a"
                  href={img}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    display: "block",
                    borderRadius: 2,
                    overflow: "hidden",
                    boxShadow: 2,
                    transition: "transform 0.2s ease",
                    "&:hover": {
                      transform: "scale(1.02)",
                    },
                  }}
                >
                  <img
                    src={img}
                    alt={`image-${index}`}
                    style={{
                      width: "100%",
                      height: "200px",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography color="text.secondary">No images to display.</Typography>
        )}
      </DialogContent>
    </BootstrapDialog>
  );
});

export default ViewImagesDialog;
